//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA CRIAR INTEGRAÇÃO ---------------//
// Responsável por criar a integração via API
export default async function createIntegrationService(formData) {
  try {
    const response = await api.post("/integracoes", formData);
    toast.success("Integração criada com sucesso");
    return response.data;
  } catch (err) {
    console.error("❌ Erro ao criar integração:", err);
    toast.error("Erro ao criar integração");
    return null;
  }
}